var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrocro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_108_251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110 220C170.751 220 220 170.751 220 110C220 49.2487 170.751 0 110 0C49.2487 0 0 49.2487 0 110C0 170.751 49.2487 220 110 220Z",
    fill: "#103F68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.862 34.499L175.312 72.1946V147.82L109.938 185.625L109.409 185.495L44.6875 147.82V72.1946L109.409 34.499H109.862ZM109.649 42.3228L51.5625 76.1478V143.867L109.643 177.685L116.737 173.58L168.438 143.846V76.1615L116.737 46.2553L109.649 42.3228ZM60.5619 115.267L77.7563 102.41L92.9569 112.118V129.58L104.459 140.663L104.452 145.86L93.3694 156.242H84.0125L60.5688 115.267H60.5619ZM114.895 145.874L114.874 140.649L126.335 129.58V112.118L141.371 102.287L158.531 115.273L135.204 156.125H125.964L114.895 145.874ZM98.6012 112.118L93.005 97.4672H126.266L120.78 112.118L122.403 128.494L109.567 128.522L96.8825 128.542L98.6012 112.118ZM109.567 93.4522L77.9556 93.4384L83.8338 67.1759H135.149L141.336 93.4728L109.567 93.4522Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_108_251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 220,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrocro);
export default __webpack_public_path__ + "static/media/crocro.a1d355fe92aca6e9fef201abd7b6148b.svg";
export { ForwardRef as ReactComponent };